export default __webpack_public_path__ + "static/media/tom-horn-gaming.d40aeab9.svg";